import { render, staticRenderFns } from "./ProductDeleteButton.vue?vue&type=template&id=1850dace&scoped=true&"
import script from "./ProductDeleteButton.vue?vue&type=script&lang=ts&"
export * from "./ProductDeleteButton.vue?vue&type=script&lang=ts&"
import style0 from "./ProductDeleteButton.vue?vue&type=style&index=0&id=1850dace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1850dace",
  null
  
)

export default component.exports